import { Injectable } from "@angular/core";
import { filter } from "lodash";
import { Effect, Actions, ofType } from "@ngrx/effects";
import { Action, Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { mergeMap } from "rxjs/operators";
import * as app from "./app.action";
import {
    LoadGameaccountDescriptionsAction,
    LoadUserAction,
    LoadUserPremiumAction,
    LoadUserTeamsAction,
    LeagueActionTypes,
    LoadLeagueCompleteAction,
    LoadGameaccountProvidersAction,
    LoadUserCompleteAction,
    LoadUserPremiumCompleteAction,
} from "@play/state";
declare var Drupal: any;

@Injectable()
export class AppEffects {
    constructor(private actions$: Actions) {}

    @Effect()
    public initApp$: Observable<Action> = this.actions$.pipe(
        ofType(app.ActionTypes.INIT),
        mergeMap(action => {
            const actions: Action[] = [];

            if (Drupal.settings.leagueId) {
                actions.push(new LoadGameaccountDescriptionsAction());
            }

            if (Drupal.settings.user && Drupal.settings.user.id) {
                const userId = +Drupal.settings.user.id;

                actions.push(new LoadUserAction(userId));
                actions.push(new LoadUserPremiumAction(userId));
                actions.push(new LoadUserTeamsAction(userId));
            } else {
                actions.push(new LoadUserCompleteAction(1 /* dummy until changed in state*/, null));
                actions.push(new LoadUserPremiumCompleteAction(1, null));
            }

            return actions;
        })
    );

    @Effect()
    public loadLeagueComplete$ = this.actions$.pipe(
        ofType(LeagueActionTypes.LOAD_LEAGUE_COMPLETE),
        mergeMap((action: LoadLeagueCompleteAction) => {
            const actions = [];

            if (!action.payload) {
                return [];
            }

            const gameaccountTypes = filter(action.payload.restrictions, restriction => restriction.type === "gameaccount").map(
                restriction => restriction.params.type
            );

            actions.push(new LoadGameaccountProvidersAction(gameaccountTypes));

            return actions;
        })
    );
}
